<template>
  <v-dialog persistent :value="show" :max-width="400">
    <v-card>
      <v-card-title>
        {{ $t('auth.access.saml_no_mobile_app_title') }}
      </v-card-title>

      <v-card-text>
        {{ $t('auth.access.saml_no_mobile_app_message') }}
      </v-card-text>

      <v-card-actions class="justify-end">
        <Button
          class="mr-2"
          color="grey"
          plain
          :text="$t('auth.access.saml_continue_in_brower_button')"
          @click="$emit('continue')"
        />

        <Button
          plain
          :text="$t('auth.access.saml_install_app_button')"
          @click="goToAppStore"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import UAParser from 'ua-parser-js'
import Button from '@/components/UI/Button'

export default {
  name: 'SAMLBrowserConfirmationDialog',

  components: {
    Button,
  },

  props: {
    show: Boolean,
  },

  methods: {
    goToAppStore() {
      const parser = new UAParser()
      const os = parser.getOS()?.name

      switch (os) {
        case 'iOS':
          return window.location.replace(this.$constants.urls.ios)
        case 'Android':
          return window.location.replace(this.$constants.urls.android)
        default:
          return ''
      }
    },
  },
}
</script>
